export default __webpack_public_path__ + "static/media/img_success.eff2d262.png";